function checkConsent() {
  const api = window.Shopify?.customerPrivacy;
  return api?.analyticsProcessingAllowed?.() || false;
}

function getProductIds() {
  const productIds = [];
  const cartItems = document.querySelectorAll('cart-drawer-items .cart-item, .drawer__contents .cart-item');
  
  cartItems.forEach(function(item) {
    const productId = item.getAttribute('data-product-id');
    if (productId) productIds.push(productId);
  });

  return productIds;
}

function trackMiniBagView() {
  if (!checkConsent()) return;

  const productIds = getProductIds();
  
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'mini_bag_view',
    product_ids: productIds
  });

}

function initMiniBagTracking() {
  const cartDrawer = document.querySelector('cart-drawer');
  if (!cartDrawer) return;

  // Store original open method
  const originalOpen = cartDrawer.open.bind(cartDrawer);

  // Override open method to fire GTM event
  cartDrawer.open = function(triggeredBy) {
    trackMiniBagView();
    return originalOpen(triggeredBy);
  };
}

function init() {
  if (checkConsent()) {
    initMiniBagTracking();
  }

  document.addEventListener('visitorConsentCollected', function() {
    if (checkConsent()) {
      initMiniBagTracking();
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
